import axios from 'axios';
import { urls } from '../config';
import { contextApp } from 'context';

export const useApiCompany = () => {
 const { auth } = contextApp();

 const CompanyApi = axios.create({
  baseURL: urls.companies(),
  headers: { 'x-access-token': auth?.token }
 });

 /* const getSetting = async (query = null) => (await SettingApi.get(`/${company}`, { params: query })).data; */

 const consultCompanyByNit = async nit => (await CompanyApi.get('/consult/' + nit)).data;

 const getCompany = async id => (await CompanyApi.get(`/${id ? id : ''}`)).data;

 const changeCompany = async id => (await CompanyApi.get('/change/' + id)).data;

 const updateCompany = async newCompany => (await CompanyApi.patch('/', newCompany)).data;

 const createCompany = async newCompany => (await CompanyApi.post('/', newCompany)).data;

 const registerCompany = async newCompany => (await CompanyApi.post('/register', newCompany)).data;

 const deletCompany = async id => (await CompanyApi.delete('/' + id)).data;

 return { getCompany, changeCompany, consultCompanyByNit, createCompany, registerCompany, updateCompany, deletCompany };
};

const token = JSON.parse(localStorage.getItem('sesion'))?.token;

/* ***************************consultCompanyByNit****************
 Esta función recibe un argumento "nit" y realiza una consulta HTTP a una API.
La dirección de la API se encuentra en un objeto llamado "urls" y se accede a ella mediante "urls.company + '/consult'". Esto crea la dirección completa a donde se hará la petición.
Luego, se crean los encabezados para la petición, incluyendo un token de autenticación llamado "x-access-token". Este token está obtenido de una variable global llamada "token".
Después, se hace una petición POST a la dirección de la API, pasando el argumento "nit" en el cuerpo de la petición y los encabezados previamente creados. La respuesta de la petición es almacenada en una variable llamada "settings".
Finalmente, la función devuelve los datos de la respuesta a través de "settings.data".
 */
export const consultCompanyByNit = async nit => {
 const url = urls.company + '/consult/' + nit;
 //const headers = { 'x-access-token': token };
 const settings = await axios.get(url);
 return settings.data;
};

export const getCompanies = async (symbol, page, token, size) => {
 const url = urls.orders({ symbol, page, size });
 const headers = { 'x-access-token': token };
 const settings = await axios.get(url, { headers });
 return settings.data; // { count, rows }
};

export const getCompany = async (token, company) => {
 const url = `${urls.company}/${company}`;
 const headers = { 'x-access-token': token };
 const settings = await axios.get(url, { headers });
 console.log(url, settings);
 return settings.data; // { count, rows }
};

export const updateCompany = async (token, newData, id) => {
 const url = urls.person(id);
 const headers = { 'x-access-token': token };
 const settings = await axios.patch(url, newData, { headers });
 return settings.data;
};
/*  *****************"createCompany"****************

Esta función toma dos argumentos: "token" y "newCompany", y una tercera argumento opcional "typePerson".
La función hace una petición POST a la URL especificada en la variable "urls.company" utilizando el método "axios.post()".
Antes de hacer la petición, la función establece un encabezado "x-access-token" que es igual a "token". Esto es para incluir el token en la solicitud, ya que probablemente sea necesario para autorizar la acción en el servidor.
Después de hacer la solicitud, la función retorna los datos en la respuesta. Estos datos se acceden a través de "settings.data".
En resumen, la función createCompany hace una petición POST a la URL especificada, incluyendo un encabezado con el token y retorna los datos de la respuesta.
 */

export const createCompany = async (token, newCompany) => {
 const url = urls.company;
 console.log(url);
 const headers = { 'x-access-token': token };
 const settings = await axios.post(url, newCompany, { headers });
 return settings.data;
};

/* ****************** "registerCompany"********************

 permite registrar una nueva empresa. La función toma como parámetro un objeto "newCompany" que representa la información de la nueva empresa a registrar.
La función utiliza la librería Axios para realizar una solicitud HTTP POST al servidor. La URL a la que se envía la solicitud es construida concatenando la propiedad "urls.company" con la ruta "/register".
Se crea un objeto "headers" que contiene un encabezado "x-access-token" que incluye el token de autenticación del usuario. La solicitud POST se envía a la URL especificada, pasando tanto el objeto "newCompany" como los encabezados como argumentos.
La respuesta del servidor se almacena en la variable "settings". La propiedad "data" de "settings" contiene la información devuelta por el servidor y se devuelve como resultado de la función. */

export const registerCompany = async newCompany => {
 const url = urls.company + '/register';
 const headers = { 'x-access-token': token };
 const settings = await axios.post(url, newCompany, { headers });
 return settings.data;
};

export const deletCompany = async (symbol, orderId, token) => {
 const url = urls.orders({ symbol, orderId });
 const headers = { 'x-access-token': token };
 const settings = await axios.delete(url, { headers });
 return settings.data; // { count, rows }
};

/* ********************* "sync_Company"*******************
 Esta función recibe tres parámetros: "beholderOrderId", "token" y "data".
La función utiliza el objeto "urls" para construir una URL que apunta a la ruta de sincronización de la empresa, agregando el valor de "beholderOrderId" a la URL.
Luego, se definen los encabezados para la solicitud con un encabezado "x-access-token" que contiene el valor del token.
Finalmente, se utiliza "axios.post" para enviar una solicitud POST a la URL especificada con los datos y los encabezados especificados. La respuesta se almacena en la variable "settings" y se devuelve el valor de "settings.data", que es un objeto que contiene "count" y "rows". */
export const syncCompany = async (beholderOrderId, token, data = []) => {
 const url = urls.orders({ sync: true, beholderOrderId });
 const headers = { 'x-access-token': token };
 const settings = await axios.post(url, data, { headers });
 return settings.data; // { count, rows }
};

export default {
 getCompanies,
 getCompany,
 updateCompany,
 createCompany,
 deletCompany,
 syncCompany
};

/* ****************DESCRIPCION GENERAL**********************

Este código es un archivo de funciones que interactúan con una API a través de la librería axios. Cada función realiza una acción diferente en la API, como obtener información de una compañía, actualizar información de una compañía, crear una compañía, registrar una compañía, eliminar una compañía y sincronizar información de una compañía.
La variable "token" se establece al leer el token de la sesión guardada en el almacenamiento local. Luego, este token se utiliza en los encabezados de cada petición para autenticar la petición.
La dirección de la API se define en un archivo externo llamado "urls" que se importa al principio del archivo. Cada función toma los parámetros necesarios y utiliza axios para hacer una petición HTTP a la API correspondiente.
Luego, la respuesta de la API se devuelve como un objeto y se accede a su propiedad "data" para obtener los datos reales.
Finalmente, se exportan todas las funciones como un objeto predeterminado, lo que significa que todas estas funciones estarán disponibles para ser importadas y utilizadas en otros archivos. */
